import React from 'react';
import { IconButton, Tooltip, alpha, useTheme } from '@mui/material';
import { Visibility } from '@mui/icons-material';

interface MonitoredAssuntoEyeIconProps {
  assuntoLabel?: string | null;
  /** Sobrescreve o texto do tooltip (ex.: norma monitorada). */
  tooltipTitle?: string;
  /** `button` na tabela de ações; `icon` no sininho e chips compactos */
  variant?: 'button' | 'icon';
  stopPropagation?: boolean;
}

export function MonitoredAssuntoEyeIcon({
  assuntoLabel,
  tooltipTitle,
  variant = 'button',
  stopPropagation = false,
}: MonitoredAssuntoEyeIconProps) {
  const theme = useTheme();
  const title =
    tooltipTitle ??
    (assuntoLabel ? `Assunto monitorado: ${assuntoLabel}` : 'Assunto monitorado');

  if (variant === 'icon') {
    return (
      <Tooltip title={title} arrow>
        <Visibility fontSize="small" sx={{ color: 'primary.main' }} />
      </Tooltip>
    );
  }

  return (
    <Tooltip title={title} arrow>
      <IconButton
        size="small"
        color="info"
        onClick={stopPropagation ? (event) => event.stopPropagation() : undefined}
        sx={{
          bgcolor: alpha(theme.palette.info.main, 0.12),
          '&:hover': { bgcolor: alpha(theme.palette.info.main, 0.2) },
        }}
      >
        <Visibility fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}
